import React from "react";

function SleepingDragon() {
  return <div className="sleeping-dragon" role="img" aria-label="A large sleeping dragon" />;
}

export default SleepingDragon;
